module.exports = __webpack_public_path__ + "img/sx2.0a233ada.svg";